
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
class ImageBox extends Vue {
  @Prop({ default: null }) readonly title!: [];
  @Prop({ default: null }) readonly imgSrc!: string;
  @Prop({ default: false }) readonly isInto!: boolean;
  downloadLink = "";
  hasImage = false;

  created(): void {
    if (this.imgSrc !== "") {
      this.getImage(this.imgSrc);
    }
  }
  @Watch("imgSrc")
  async onPropertyChange(value: string): Promise<void> {
    this.downloadLink = "";
    this.hasImage = false;
    this.getImage(value);
  }

  async getImage(path: string): Promise<void> {
    await this.$store
      .dispatch("authenication/getImageSrcFromRemote", path)
      .then((result) => {
        if (result === "Error") {
          this.downloadLink = "";
          this.hasImage = false;
        } else {
          this.downloadLink = result;
          this.hasImage = true;
        }
      })
      .catch(() => {
        this.downloadLink = "";
        this.hasImage = false;
      });
  }
  showImageSelector(): void {
    this.$emit("showImageSelector");
  }
  showClear(): void {
    this.$emit("clearImage", this.isInto);
  }
}

export default ImageBox;
